<template>
  <div>
    <div class="pc-translate-intro">
      <h2>{{ title }}介绍</h2>
      <div class="pc-intro" v-if="!isEditting">
        <div class="chinese">
          <h4>中文介绍：</h4>
          <p v-if="chineseText" v-html="chineseText"></p>
          <p v-if="!chineseText">暂无</p>
        </div>
        <div class="english">
          <h4>Introduction：</h4>
          <p v-if="englishText" v-html="englishText"></p>
          <p v-if="!englishText">暂无</p>
        </div>
      </div>
      <div class="pc-intro-edit">
        <TemplateUeditor v-show="isEditting" v-model="content.chineseText" />
        <TranslateText
          v-if="isEditting"
          :chinese="content.chineseText"
          :english="content.englishText"
          @returnTranslate="returnTranslate"
        />
        <h4 style="margin-bottom: 15px" v-show="isEditting">英文翻译</h4>
        <TemplateUeditor v-show="isEditting" v-model="content.englishText" />
      </div>
    </div>
  </div>
</template>
<script>
import TemplateUeditor from "./Ueditor";
import TranslateText from "./TranslateText";
export default {
  props: {
    englishText: String,
    chineseText: String,
    title: String,
    isEditting: Boolean,
  },
  components: {
    TemplateUeditor,
    TranslateText,
  },
  data() {
    return {
      content: {
        englishText: "",
        chineseText: "",
      },
    };
  },
  mounted() {
    this.content.englishText = this.englishText;
    this.content.chineseText = this.chineseText;
  },
  watch: {
    englishText() {
      this.content.englishText = this.englishText;
    },
    chineseText() {
      console.log(this.content.chineseText);
      this.content.chineseText = this.chineseText;
    },
  },
  methods: {
    getContent() {
      return this.content.englishText;
    },
    getContent1() {
      return this.content.chineseText;
    },
    returnTranslate(data, flag) {
      flag == 1
        ? (this.content.englishText = data)
        : (this.content.chineseText = data);
      console.log(data);
      console.log(flag);
      // this.$emit("getTranslateContent", this.content)
    },
  },
};
</script>
<style lang="scss" scoped>
.pc-translate-intro {
  // @include box-model;
  .pc-intro {
    .chinese,
    .english {
      margin-top: 29px;
      margin-bottom: 40px;
      font-size: 14px;
      line-height: 21px;
      color: #434343;
      font-family: $english;
      h4 {
        height: 21px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #434343;
        line-height: 21px;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #434343;
        line-height: 21px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/componentSet/EditWithTranslator.vue